import React from 'react';
import ReactDOM from 'react-dom/client';
import './profile.css';
import Portfolio from './profile.jsx';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Portfolio />
  </React.StrictMode>
);